<template>
  <div
    class="cl_avatar"
    :class="{ round }"
    :style="{
      width: width + 'px',
      height: height + 'px',
      borderRadius: radius,
    }"
  >
    <img
      class="cl_avatar_img"
      :src="src || require('@i/common/default_avatar.svg')"
      alt
    />
  </div>
</template>

<script>
/**
 * ComponentName: 头像显示
 * Created Date:2022/4/21
 * Author: Nancy
 * 组件说明：
 * round: 是否是圆形，默认是正方形
 * eg:
 * <cl-avatar :src="avatar" :round="true" width="32" height="32"></cl-avatar>
 */
export default {
  name: "cl-avatar",
  data() {
    return {};
  },
  props: {
    src: {
      type: String,
      default: "",
    },
    width: {
      type: [String, Number],
      default: 24,
    },
    height: {
      type: [String, Number],
      default: 24,
    },
    round: {
      // true是圆形头像 默认是false（方形头像
      type: Boolean,
      default: false,
    },
    radius: {
      type: String,
      default: "",
    },
  },

  created() {},

  components: {},

  computed: {},

  mounted() {},

  methods: {},
};
</script>
<style lang='scss' scoped>
.cl_avatar {
  border-radius: $base-border-radius-small;
  overflow: hidden;
  background-color: #f0f0f0;
  display: inline-block;
  box-sizing: border-box;
  flex-shrink: 0;
  img {
    width: 100%;
  }
}
.round {
  border-radius: 50%;
}
</style>